import { Sidebar } from "../components/SideBar";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./Home";
import Settings from "./Settings";
import { AlertsProvider } from "context/AlertsContext";
import Login from "./Login";
import { useAuth } from "context/AuthContext";
import Spinner from "components/ui/Spinner";
import { StudentsProvider } from "context/StudentsContext";
import { FloatingChat } from "../components/FloatingChat";
import { useState, useEffect } from "react";

export default function App() {
  const { isAuthenticated, teacherId } = useAuth();
  const [isStudentListOpen, setIsStudentListOpen] = useState(false);
  const [isFloatingChatOpen, setIsFloatingChatOpen] = useState(false);
  const location = useLocation();

  const closeFloatingChat = () => setIsFloatingChatOpen(false);

  // Close FloatingChat when navigating to settings or when student list is opened
  useEffect(() => {
    if (location.pathname === "/settings" || isStudentListOpen) {
      setIsFloatingChatOpen(false);
    }
  }, [location.pathname, isStudentListOpen]);

  if (!isAuthenticated) {
    return (
      <div className="flex h-screen w-screen bg-background text-gray-900 items-center justify-center">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </div>
    );
  }

  if (!teacherId) {
    return <Spinner className="h-screen" />;
  }

  return (
    <StudentsProvider>
      <AlertsProvider teacherId={teacherId}>
        <div className="flex h-screen w-screen bg-gray-50 text-gray-900 overflow-hidden">
          <Sidebar
            teacherId={teacherId}
            isStudentListOpen={isStudentListOpen}
            onChatClick={closeFloatingChat}
          />
          <div className="flex flex-1 min-w-0">
            <Routes>
              <Route
                path="/"
                element={<Home onStudentListToggle={setIsStudentListOpen} />}
              />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
          <FloatingChat
            teacherId={teacherId}
            isOpen={isFloatingChatOpen}
            onToggle={setIsFloatingChatOpen}
          />
        </div>
      </AlertsProvider>
    </StudentsProvider>
  );
}
